import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EMPTY_ORDERS_REPORT_FILTERS,
  OrdersReportFilterChip,
  OrdersReportFilterOptions,
  OrdersReportFiltersState
} from 'src/entities/order';

@Component({
  selector: 'app-orders-report-filters',
  templateUrl: './orders-report-filters.component.html',
  styleUrls: ['./orders-report-filters.component.css']
})
export class OrdersReportFiltersComponent {
  @Input() filters: OrdersReportFiltersState = {
    ...EMPTY_ORDERS_REPORT_FILTERS
  };
  @Input() filterOptions: OrdersReportFilterOptions = {
    years: [],
    providers: [],
    orderStatuses: []
  };
  @Input() activeFilterChips: OrdersReportFilterChip[] = [];
  @Input() disabled = false;

  @Output() filtersChange = new EventEmitter<OrdersReportFiltersState>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() removeFilter = new EventEmitter<OrdersReportFilterChip['id']>();

  readonly trackByYear = (_: number, year: string) => year;
  readonly trackByProvider = (_: number, provider: string) => provider;
  readonly trackByStatus = (_: number, status: string) => status;
  readonly trackByChip = (_: number, chip: OrdersReportFilterChip) => chip.id;

  get hasActiveFilters(): boolean {
    return this.activeFilterChips.length > 0;
  }

  onFieldChange(patch: Partial<OrdersReportFiltersState>): void {
    this.filtersChange.emit({
      ...this.filters,
      ...patch
    });
  }

  onSearchChange(value: string): void {
    this.onFieldChange({ searchValue: value ?? '' });
  }

  onYearChange(value: string | null): void {
    this.onFieldChange({ yearFile: value });
  }

  onProviderChange(value: string | null): void {
    this.onFieldChange({ providerName: value });
  }

  onStatusChange(value: string | null): void {
    this.onFieldChange({ orderStatus: value });
  }

  onPaidAtFromChange(value: Date | null): void {
    const next = { ...this.filters, paidAtFrom: value };
    this.filters = next;
    if (next.paidAtFrom && next.paidAtTo) {
      this.filtersChange.emit(next);
    }
  }

  onPaidAtToChange(value: Date | null): void {
    const next = { ...this.filters, paidAtTo: value };
    this.filters = next;
    if (next.paidAtFrom && next.paidAtTo) {
      this.filtersChange.emit(next);
    }
  }

  clearPaidAtRange(): void {
    this.onFieldChange({
      paidAtFrom: null,
      paidAtTo: null
    });
  }
}
